export const flightFromAiSidePanelApiKey = "parseFlightSuccess";
